export const flightFromAiSidePanelApiKey = "parseFlightSuccess";
